<div class="dialog-container">
  <label class="confirmationLabel" id="siteInductionConfirmationLabel">
    {{ title }}
  </label>
  <div class="divider"></div>

  <div class="confirmation-brand-row" fxLayout="row" fxLayoutAlign="space-between center">
    <div class="brand-logo-container">
      @if (brandImageUrl) {
      <img class="brand-logo" [src]="brandImageUrl" [alt]="validationResult?.siteInduction?.brandName" />
      }
    </div>
    <div class="status-icon-container" fxLayoutAlign="center center">
      @if (isSuccess) {
      <mat-icon class="status-icon color-city-green">check_circle</mat-icon>
      } @else {
      <mat-icon class="status-icon color-city-red">cancel</mat-icon>
      }
    </div>
  </div>

  <div class="confirmation-message color-dark-blue">
    @if (isSuccess) {
    <span>{{ successMessage }}</span>
    } @else {
    <span>{{ errorMessagePrefix }}</span>
    <div class="confirmation-error-reason color-city-red">
      <span>{{ "site_induction_confirmation_error_reason" | translate }}</span
      ><span>{{ errorReason }}</span>
    </div>
    }
  </div>

  <div class="divider"></div>
  <button
    type="button"
    id="site_induction_confirmation_continue"
    mat-raised-button
    (click)="onContinue()"
  >
    {{ "site_induction_confirmation_continue" | translate }}
  </button>

  @if (!isSuccess) {
  <div class="divider"></div>
  <button
    type="button"
    id="site_induction_confirmation_resubmit"
    mat-stroked-button
    class="color-city-blue btn-border-color"
    (click)="onResubmit()"
  >
    {{ "site_induction_confirmation_resubmit" | translate }}
  </button>
  }
</div>
